module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "klickbox-edit-item": "general",
      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
    }
  }, [_c('div', {
    staticClass: "kbx-content"
  }, [_c('title-preview'), _vm._v(" "), _c('description')], 1)])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-53cbdbbc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/thanks/Main.vue
 ** module id = 830
 ** module chunks = 1
 **/